// Turkish translations - Phase 02 additions merged with Phase 01
const tr = {
    app: {
        name: "OMB Agency ERP PRO",
        shortName: "OMB",
        tagline: "Ajans Yönetim Sistemi",
    },
    common: {
        save: "Kaydet",
        cancel: "İptal",
        edit: "Düzenle",
        delete: "Sil",
        add: "Ekle",
        create: "Oluştur",
        loading: "Yükleniyor\u2026",
        search: "Arama yapın...",
        confirm: "Onayla",
        back: "Geri",
        close: "Kapat",
        yes: "Evet",
        no: "Hayır",
        signIn: "Giriş Yap",
        signOut: "Çıkış Yap",
        rememberMe: "Beni Hatırla",
        forgotPassword: "Şifremi Unuttum",
        email: "E-posta",
        password: "Şifre",
        newPassword: "Yeni Şifre",
        currentPassword: "Mevcut Şifre",
        confirmPassword: "Şifre (Tekrar)",
        fullName: "Ad Soyad",
        firstName: "Ad",
        lastName: "Soyad",
        phone: "Telefon",
        title: "Pozisyon",
        department: "Departman",
        avatar: "Profil Fotoğrafı",
        settings: "Ayarlar",
        profile: "Profilim",
        dashboard: "Kontrol Paneli",
        notifications: "Bildirimler",
        theme: "Tema",
        light: "Açık",
        dark: "Koyu",
        system: "Sistem",
        turkish: "Türkçe",
        language: "Dil",
        role: "Rol",
        active: "Aktif",
        inactive: "Pasif",
        onLeave: "İzinli",
        terminated: "Ayrılmış",
        status: "Durum",
        actions: "İşlemler",
        details: "Detay",
        photo: "Fotoğraf",
        birthDate: "Doğum Tarihi",
        hireDate: "İşe Başlama Tarihi",
        notes: "Notlar",
        lastLogin: "Son Giriş",
        never: "Henüz giriş yapmadı",
        quickAction: "Hızlı İşlem",
        viewAll: "Tümünü Gör",
        allEvents: "Tüm Etkinlikler",
        allActivities: "Tüm Aktiviteler",
        greeting: "Merhaba",
        today: "Bugün",
        page: "Sayfa",
        of: "/",
        rowsPerPage: "Sayfa başına",
        showing: "Gösteriliyor",
        results: "sonuç",
        selected: "seçili",
        all: "Tümü",
        filter: "Filtrele",
        clear: "Temizle",
        clearFilters: "Filtreleri Temizle",
        exportExcel: "Excel",
        exportPdf: "PDF",
        bulkActions: "Toplu İşlem",
        activate: "Aktif Et",
        deactivate: "Pasif Et",
        deleteSelected: "Seçilenleri Sil",
        noResults: "Sonuç bulunamadı.",
        confirmDelete: "Silme onayı",
        confirmDeleteBody: "Bu işlem geri alınamaz. Devam etmek istediğinize emin misiniz?",
        yesDelete: "Evet, sil",
        added: "eklendi",
        updated: "güncellendi",
        deleted: "silindi",
        saved: "kaydedildi",
        createdAt: "Oluşturulma",
        updatedAt: "Güncellenme",
        description: "Açıklama",
        name: "İsim",
        manager: "Yönetici",
        none: "Yok",
        employeeCount: "Personel Sayısı",
        systemRole: "Sistem Rolü",
    },
    login: {
        title: "Hesabınıza giriş yapın",
        subtitle: "OMB Agency ERP PRO kontrol paneline erişin",
        emailPlaceholder: "ornek@ombajans.com",
        passwordPlaceholder: "Şifrenizi girin",
        signInCta: "Giriş Yap",
        errorInvalid: "E-posta veya şifre hatalı.",
        errorNetwork: "Bağlantı hatası. Lütfen tekrar deneyin.",
        welcomeBack: "Tekrar hoş geldiniz",
        heroTitle: "Ajansınızı tüm yönleriyle tek platformdan yönetin.",
        heroSubtitle: "Müşteri, proje, görev, finans ve içerik takvimini tek merkezden yönetmenizi sağlayan premium ajans ERP çözümü.",
        footer: "Digital Agency ERP",
        or: "veya",
        needHelp: "Yardıma mı ihtiyacınız var?",
        contactSupport: "Destek ile iletişime geçin",
    },
    forgot: {
        title: "Şifremi Unuttum",
        subtitle: "Kayıtlı e-posta adresinizi girin, size sıfırlama bağlantısı gönderelim.",
        cta: "Sıfırlama Bağlantısı Gönder",
        successTitle: "E-posta gönderildi",
        successBody: "Eğer bu adres sistemde kayıtlı ise şifre sıfırlama yönergesi gönderilmiştir. Lütfen gelen kutunuzu kontrol edin.",
        backToLogin: "Giriş sayfasına dön",
    },
    sidebar: {
        dashboard: "Kontrol Paneli",
        clients: "Müşteriler",
        projects: "Projeler",
        tasks: "Görevler",
        contentCalendar: "İçerik Takvimi",
        finance: "Maliye",
        proposals: "Teklifler",
        contracts: "Sözleşmeler",
        reports: "Raporlar",
        employees: "Personeller",
        departments: "Departmanlar",
        aiAssistant: "AI Asistan",
        settings: "Ayarlar",
        expenses: "Gider Yönetimi",
        shootPlanner: "Görsel Çekim Planlayıcı",
        portal: "Müşteri Portalı",
    },
    placeholder: {
        comingSoon: "Bu modül sonraki geliştirme aşamasında oluşturulacaktır.",
        stayTuned: "Yakında hizmetinizde. Çalışmalarımız devam etmektedir.",
        underDevelopment: "Geliştirme Aşamasında",
    },
    dashboard: {
        stats: {
            activeProjects: "Aktif Projeler",
            todayTasks: "Bugünkü Görevler",
            pendingApprovals: "Bekleyen Onaylar",
            completedTasks: "Tamamlanan Görevler",
            monthlyRevenue: "Aylık Gelir",
            monthlyExpense: "Aylık Gider",
            monthlyProfit: "Aylık Kâr",
            revenueDistribution: "Gelir Dağılımı",
            upcomingDeliveries: "Yaklaşan Teslimler",
            recentActivities: "Son Aktiviteler",
            calendar: "Takvim",
            comparedLastMonth: "Geçen aya göre",
            thisMonth: "Bu ay",
            waitingForApproval: "Onay bekleyen işlemler",
            completedThisMonth: "Bu ay tamamlananlar",
            monthTarget: "Hedef",
            target: "Hedef",
            thisMonthShare: "Bu ayın dağılımı",
        },
        quickActions: {
            title: "Hızlı İşlemler",
            newClient: "Yeni Müşteri",
            newClientDesc: "Müşteri ekle",
            newProject: "Yeni Proje",
            newProjectDesc: "Proje başlat",
            newTask: "Yeni Görev",
            newTaskDesc: "Görev oluştur",
            newIncome: "Yeni Gelir",
            newIncomeDesc: "Gelir ekle",
            newExpense: "Yeni Gider",
            newExpenseDesc: "Gider ekle",
            uploadFile: "Dosya Yükle",
            uploadFileDesc: "Dosya yükle",
        },
        activity: {
            newTaskCreated: "Yeni görev oluşturuldu",
            projectUpdated: "Proje güncellendi",
            invoiceCreated: "Fatura oluşturuldu",
            proposalApproved: "Teklif onaylandı",
            newClient: "Yeni müşteri eklendi",
        },
        greetings: {
            morning: "Günaydın",
            day: "Merhaba",
            evening: "İyi akşamlar",
        },
        todayIs: "Bugün",
    },
    profile: {
        title: "Profilim",
        subtitle: "Kişisel bilgilerinizi güncelleyin.",
        personalInfo: "Kişisel Bilgiler",
        accountInfo: "Hesap Bilgileri",
        security: "Güvenlik",
        changePassword: "Şifre Değiştir",
        savedSuccess: "Profil bilgileriniz güncellendi.",
        passwordChanged: "Şifreniz başarıyla güncellendi.",
        lastLogin: "Son giriş",
        joined: "Katılım tarihi",
    },
    settings: {
        title: "Ayarlar",
        subtitle: "Uygulama tercihlerinizi yönetin.",
        appearance: "Görünüm",
        appearanceDesc: "Arayüz temasını ve dil tercihlerinizi ayarlayın.",
        notifications: "Bildirimler",
        notificationsDesc: "Nasıl bilgilendirilmek istediğinizi seçin.",
        emailNotifications: "E-posta bildirimleri",
        pushNotifications: "Anlık bildirimler",
        desktopNotifications: "Masaüstü bildirimleri",
        security: "Güvenlik",
        securityDesc: "Hesabınızın güvenliğini yönetin.",
        saved: "Ayarlar kaydedildi.",
        timezone: "Saat Dilimi",
        management: "Yönetim",
        managementDesc: "Roller, yetkiler ve denetim kayıtları.",
        openRoles: "Rolleri Yönet",
        openPermissions: "Yetki Kataloğunu Gör",
        openAudit: "Denetim Kayıtları",
    },
    validation: {
        required: "Bu alan zorunludur.",
        emailInvalid: "Geçerli bir e-posta girin.",
        passwordMin: "Şifre en az 8 karakter olmalı.",
        passwordsMismatch: "Şifreler eşleşmiyor.",
    },
    personnel: {
        title: "Personeller",
        subtitle: "Tüm personellerinizi tek yerden yönetin.",
        newPersonnel: "Yeni Personel",
        totalPersonnel: "Toplam Personel",
        activePersonnel: "Aktif Personel",
        onLeave: "İzinde",
        newThisMonth: "Bu ay eklenen",
        filters: {
            allDepartments: "Tüm Departmanlar",
            allRoles: "Tüm Roller",
            allStatuses: "Tüm Durumlar",
        },
        columns: {
            photo: "Fotoğraf",
            fullName: "Ad Soyad",
            department: "Departman",
            title: "Pozisyon",
            email: "E-Posta",
            phone: "Telefon",
            status: "Durum",
            lastLogin: "Son Giriş",
            actions: "İşlemler",
        },
        create: {
            title: "Yeni Personel",
            subtitle: "Ajansınıza yeni bir personel ekleyin.",
            personalInfo: "Kişisel Bilgiler",
            workInfo: "İş Bilgileri",
            security: "Güvenlik",
            success: "Personel başarıyla oluşturuldu.",
        },
        detail: {
            personalInfo: "Kişisel Bilgiler",
            contactInfo: "İletişim Bilgileri",
            passwordChange: "Şifre Değiştir",
            profilePhoto: "Profil Fotoğrafı",
            twoFactor: "İki Faktörlü Doğrulama",
            loginHistory: "Giriş Geçmişi",
            twoFactorComingSoon: "İki faktörlü doğrulama sonraki geliştirme aşamasında eklenecektir.",
            resetPassword: "Şifre Sıfırla",
            tempPasswordGenerated: "Geçici şifre oluşturuldu",
            confirmDelete: "Personeli sil",
            confirmDeleteBody: "Bu personel kalıcı olarak silinecek. Devam etmek istediğinize emin misiniz?",
        },
        bulk: {
            activateConfirm: "Seçili personelleri aktif etmek istediğinize emin misiniz?",
            deactivateConfirm: "Seçili personelleri pasif etmek istediğinize emin misiniz?",
            deleteConfirm: "Seçili personeller kalıcı olarak silinecek. Devam edilsin mi?",
        },
    },
    departments: {
        title: "Departmanlar",
        subtitle: "Ajansınızın departmanlarını yönetin.",
        new: "Yeni Departman",
        totalDepartments: "Toplam Departman",
        totalManagers: "Toplam Yönetici",
        activeDepartments: "Aktif Departmanlar",
        selectManager: "Yönetici Seç",
        noManager: "Yönetici atanmamış",
        confirmDelete: "Departmanı sil",
        confirmDeleteBody: "Bu departman kalıcı olarak silinecek.",
        deptEmployees: "Departman Çalışanları",
    },
    roles: {
        title: "Roller",
        subtitle: "Sistem rollerini ve özel rolleri yönetin.",
        new: "Yeni Rol",
        permissionMatrix: "Yetki Matrisi",
        permissionMatrixDesc: "Rolde etkin olan yetkileri işaretleyin.",
        selectAll: "Tümünü Seç",
        clearAll: "Tümünü Kaldır",
        rolePermissions: "Rol Yetkileri",
        totalRoles: "Toplam Rol",
        systemRoles: "Sistem Rolleri",
        customRoles: "Özel Roller",
    },
    permissions: {
        title: "Yetkiler",
        subtitle: "Sistem yetki kataloğu (kategori bazında).",
        totalPermissions: "Toplam Yetki",
        totalCategories: "Kategori Sayısı",
    },
    audit: {
        title: "Denetim Kayıtları",
        subtitle: "Sistemdeki tüm kritik işlemlerin denetim izleri.",
        columns: {
            timestamp: "Tarih",
            user: "Kullanıcı",
            module: "Modül",
            action: "Aksiyon",
            entity: "Nesne",
            ip: "IP",
        },
        allModules: "Tüm Modüller",
        allActions: "Tüm Aksiyonlar",
        allUsers: "Tüm Kullanıcılar",
        dateFrom: "Başlangıç",
        dateTo: "Bitiş",
    },
    status: {
        active: "Aktif",
        inactive: "Pasif",
        on_leave: "İzinli",
        terminated: "Ayrılmış",
    },
    forbidden: {
        title: "Yetkisiz Erişim",
        body: "Bu sayfayı görüntülemek için yetkiniz bulunmuyor. Lütfen yöneticinizle iletişime geçin.",
    },
    crm: {
        title: "Müşteriler",
        subtitle: "Müşteri ilişkilerinizi tek merkezden yönetin.",
        new: "Yeni Müşteri",
        totalCustomers: "Toplam Müşteri",
        activeCustomers: "Aktif Müşteri",
        prospects: "Potansiyel",
        strategic: "Stratejik",
        allStatuses: "Tüm Durumlar",
        allSegments: "Tüm Segmentler",
        allTypes: "Tüm Tipler",
        allManagers: "Tüm Temsilciler",
        types: { corporate: "Kurumsal", individual: "Bireysel" },
        statuses: { active: "Aktif", passive: "Pasif", prospect: "Potansiyel", lost: "Kaybedilen" },
        segments: { strategic: "Stratejik", premium: "Premium", standard: "Standart", basic: "Temel" },
        columns: {
            logo: "Logo", name: "Müşteri Adı", industry: "Sektör",
            manager: "Müşteri Temsilcisi", segment: "Segment", status: "Durum",
            phone: "Telefon", email: "E-posta", updated: "Güncellenme",
        },
        create: {
            title: "Yeni Müşteri",
            subtitle: "Yeni bir müşteri ekleyin ve iletişim bilgilerini kaydedin.",
            basicInfo: "Temel Bilgiler",
            contactInfo: "İletişim Bilgileri",
            legalInfo: "Yasal Bilgiler",
            success: "Müşteri başarıyla oluşturuldu.",
        },
        detail: {
            overview: "Genel Bakış",
            contacts: "İletişim Kişileri",
            addresses: "Adresler",
            socials: "Sosyal Hesaplar",
            packages: "Paketler",
            assignments: "Ekip Ataması",
            meetings: "Toplantılar",
            files: "Dosyalar",
            notes: "Notlar",
            activity: "Aktivite",
            info: "Bilgiler",
            noPrimaryContact: "Birincil iletişim kişisi yok",
            noManager: "Temsilci atanmamış",
            confirmDelete: "Müşteriyi sil",
            confirmDeleteBody: "Bu müşteri ve tüm alt kayıtları kalıcı olarak silinecek. Devam edilsin mi?",
        },
        contact: {
            title: "İletişim Kişileri",
            new: "Yeni İletişim Kişisi",
            fullName: "Ad Soyad", role: "Ünvan", primary: "Birincil",
            noItems: "Henüz iletişim kişisi eklenmemiş.",
        },
        address: {
            title: "Adresler",
            new: "Yeni Adres",
            label: "Etiket", line1: "Adres Satırı", district: "İlçe",
            city: "Şehir", postalCode: "Posta Kodu", country: "Ülke",
            noItems: "Henüz adres eklenmemiş.",
        },
        social: {
            title: "Sosyal Hesaplar",
            new: "Yeni Sosyal Hesap",
            platform: "Platform", handle: "Kullanıcı Adı", url: "URL",
            followers: "Takipçi",
            noItems: "Henüz sosyal hesap eklenmemiş.",
        },
        package: {
            title: "Paketler",
            new: "Yeni Paket",
            packageName: "Paket Adı", price: "Fiyat", cycle: "Faturalandırma",
            services: "Hizmetler", cycles: { monthly: "Aylık", quarterly: "3 Aylık", yearly: "Yıllık", one_time: "Tek Seferlik" },
            noItems: "Henüz paket tanımlanmamış.",
        },
        assignment: {
            title: "Ekip Ataması",
            new: "Personel Ata",
            employee: "Personel", roleOnAccount: "Görev", primary: "Birincil",
            noItems: "Henüz atanmış personel yok.",
        },
        meeting: {
            title: "Toplantılar",
            new: "Yeni Toplantı",
            subject: "Konu", type: "Tür", starts: "Başlangıç", ends: "Bitiş",
            location: "Konum", attendees: "Katılımcılar",
            types: { call: "Telefon", video: "Video", onsite: "Sahada", office: "Ofis", other: "Diğer" },
            statuses: { scheduled: "Planlandı", done: "Tamamlandı", cancelled: "İptal Edildi" },
            noItems: "Toplantı bulunmuyor.",
        },
        file: {
            title: "Dosyalar",
            new: "Yeni Dosya",
            name: "Dosya Adı", url: "URL", category: "Kategori",
            noItems: "Henüz dosya eklenmemiş.",
        },
        note: {
            title: "Notlar",
            new: "Yeni Not",
            pin: "Sabitle", pinned: "Sabitlenmiş",
            placeholder: "Bir not yazın…",
            noItems: "Henüz not eklenmemiş.",
        },
        activity: {
            title: "Aktivite Akışı",
            noItems: "Aktivite yok.",
        },
    },
};

export default tr;
